// @embedpdf/snippet relies on import.meta.url inside its engine scripts (worker-engine,
// direct-engine) to resolve the pdfium WASM and Web Worker URLs. Webpack 4 does not
// support import.meta.url, so we must load the module at runtime from CDN via a dynamic
// import() that webpack cannot statically analyse. Using new Function prevents webpack
// from trying to bundle the CDN URL as a local dependency.
const CDN_SNIPPET_URL = 'https://cdn.jsdelivr.net/npm/@embedpdf/snippet@2/dist/embedpdf.js';

let embedPdfPromise = null;

// eslint-disable-next-line import/prefer-default-export
export function loadEmbedPDF() {
  if (!embedPdfPromise) {
    // eslint-disable-next-line no-new-func
    embedPdfPromise = new Function('u', 'return import(u)')(CDN_SNIPPET_URL).then((mod) => mod.default);
  }
  return embedPdfPromise;
}
